<template>
  <v-tooltip
    open-delay=1000
    :left="tooltipLeft"
    :right="tooltipRight"
    :top="tooltipTop"
    :bottom="tooltipBottom"
    >
    <template v-slot:activator="{ on }">
      <span v-on="on" v-if="enableToolTip">
        <v-select
          v-bind="computedProps"
          v-on="computedListeners"
          :placeholder="phtext"
          :tabindex="readonly ? -1 : 0"
        >
          <template v-slot:label v-if="label !== undefined && label !== null && label !== ''">
            {{ label }}
            <span v-if="required" class="mandatory">必須</span>
          </template>
        </v-select>
      </span>
      <v-select
        v-else
        v-bind="computedProps"
        v-on="computedListeners"
        :placeholder="phtext"
        :tabindex="readonly ? -1 : 0"
      >
          <template v-slot:label v-if="label !== undefined && label !== null && label !== ''">
            {{ label }}
            <span v-if="required" class="mandatory">必須</span>
          </template>
        </v-select>
    </template>
    <span v-html="tooltipText"></span>
  </v-tooltip>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VSelect } from 'vuetify/lib'

/**
 * @file DDv2用単一ドロップダウン
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-select/
 * @example
  <dd-drop-down
    v-model="dropdown1value"
    :items="dropDownItems"
    :required="true"
    />
  data: () => ({
    dropDownItems: [
      { value: null, text: '' },
      { value: '0', text: 'Windows 3.1' },
      { value: '1', text: 'Windows 95' },
      { value: '2', text: 'Windows 98' },
      { value: '3', text: 'Windows 98 SE' },
      { value: '4', text: 'Windows 2000' },
      { value: '5', text: 'Windows Me' },
      { value: '6', text: 'Windows XP' },
      { value: '7', text: 'Windows Vista' },
      { value: '8', text: 'Windows 8' },
      { value: '9', text: 'Windows 10' }
    ]
  })
 */
export default {
  name: 'DdDropDown',
  extends: VSelect,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * 太枠
     */
    emphasis: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    phtext: '選択して下さい',
    invalidMessage: ''
  }),
  created () {
  },
  mounted () {
    console.log(this.$props)
    this.invalidMessage = this.errorMessages
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        class: (this.required ? ' required-item' : this.class) + (this.emphasis ? ' emphasis-item' : ''),
        hideDetails: 'auto',
        outlined: true,
        dense: true,
        multiple: false,
        error: this.hasError,
        errorMessages: this.invalidMessage,
        itemText: controls.SelectTextPropName,
        itemValue: controls.SelectValuePropName
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.value,
        length: this.length
      }

      this.invalidMessage = undefined
      const validatorList = []

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}
</script>
<style scoped>
::v-deep .v-select__selections input {
  max-width: 0px;
  max-height: 0px;
}
</style>
